// Bluetooth SIG assigned numbers for the Fitness Machine Service.
// Spec: Fitness Machine Service v1.0 (see Bluetooth SIG).

export const FTMS_SERVICE_UUID = 0x1826;

// Mandatory characteristic — describes machine capabilities (not type).
export const FITNESS_MACHINE_FEATURE_UUID = 0x2acc;

// Per-equipment data characteristics. Equipment *type* is detected by which
// of these the GATT server exposes, not by anything in the feature bitmask.
export const TREADMILL_DATA_UUID = 0x2acd;
export const CROSS_TRAINER_DATA_UUID = 0x2ace;
export const STEP_CLIMBER_DATA_UUID = 0x2acf;
export const STAIR_CLIMBER_DATA_UUID = 0x2ad0;
export const ROWER_DATA_UUID = 0x2ad1;
export const INDOOR_BIKE_DATA_UUID = 0x2ad2;

// Control + status characteristics (not yet consumed, but reserved for later).
export const FITNESS_MACHINE_CONTROL_POINT_UUID = 0x2ad9;
export const FITNESS_MACHINE_STATUS_UUID = 0x2ada;
